import { render } from "./EventList.vue?vue&type=template&id=0a2095f5&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=0a2095f5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0a2095f5"

export default script